<template>
  <div class="container theme-platformbrand">
    <div class="row" v-if="isValidProgram">
      <div class="col-lg-4">
        <div class="card mb-3">
          <div class="card-body">
            <div class="row">
              <div class="col-xs-12 mb-2">
                <h4 class="card-title mb-3">
                  <a title="Back to participants selection" href="#" @click="backSelectParticipants">
                    <i class="bi bi-arrow-left"></i>
                  </a>
                  {{terms?.Program}} Details
                </h4>
                <p class="fs-6 fw-semibold mb-0">{{terms?.Program}}</p>
                <p class="fs-6 card-text" v-if="programData">{{ programData.programName }}</p>
              </div>
              <div class="col-xs-12 mb-2">
                <p class="fs-6 fw-semibold mb-0">Location</p>
                <p class="fs-6 card-text" v-if="programData">{{ programData.venueName }}</p>
              </div>
              <div class="col-xs-12">
                <p class="fs-6 fw-semibold mb-0">Cost</p>
                <p class="fs-6 card-text" v-if="programData">
                  {{
                    `${currency}${(
                      Math.round(programData.programCostFirstParticipant * 100) / 100
                    ).toFixed(2)} for the first participant`
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="card form-highlight pb-3 mb-3" v-if="isMyGolf">
          <div class="card-body">
            <h4 class="card-title">Guardian Details</h4>
            <div class="row">
              <div class="col-sm-12 mb-2">
                <label for="guardianFirstName" class="form-label">First Name *</label>
                <input type="text" maxlength="100" @focus="guardianValidation.guardianFirstName.dirty = true"
                  @blur="validate" class="form-control" id="guardianFirstName" v-model="vm.guardianFirstName"
                  placeholder="John" />
                <label class="error" v-if="!guardianValidation.guardianFirstName.valid">{{
                  guardianValidation.guardianFirstName.errorMessage
                }}</label>
              </div>
              <div class="col-sm-12 mb-2">
                <label for="guardianLastName" class="form-label">Last Name *</label>
                <input type="text" maxlength="100" @focus="guardianValidation.guardianLastName.dirty = true"
                  @blur="validate" class="form-control" id="guardianLastName" v-model="vm.guardianLastName"
                  placeholder="Doe" />
                <label class="error" v-if="!guardianValidation.guardianLastName.valid">{{
                  guardianValidation.guardianLastName.errorMessage
                }}</label>
              </div>
              <div class="col-sm-12 mb-2">
                <label for="guardianFullName1" class="form-label">Email *</label>
                <input type="text" maxlength="100" @focus="guardianValidation.guardianEmail.dirty = true"
                  @blur="validate" class="form-control" id="guardianFullName1" v-model="vm.guardianEmail"
                  placeholder="john@doe.com" />
                <label class="error" v-if="!guardianValidation.guardianEmail.valid">{{
                  guardianValidation.guardianEmail.errorMessage
                }}</label>
              </div>
              <div class="col-sm-12">
                <label for="guardianFullName2" class="form-label">Phone *</label>
                <input type="text" maxlength="100" class="form-control" id="guardianFullName2"
                  @blur="guardianValidation.guardianPhone.dirty = true" v-model="vm.guardianPhone"
                  placeholder="0491 570 159" @input="validate" />
                <label class="error" v-if="!guardianValidation.guardianPhone.valid">{{
                  guardianValidation.guardianPhone.errorMessage
                }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="d-buttons-container d-none d-lg-block">
          <div class="row" v-if="!startLoading">
            <div class="col-sm-6 col-xs-12">
              <button class="btn btn-primary w-100" :disabled="isSavingRegistration" @click="onSave">
                <span v-if="isSavingRegistration" class="spinner-border spinner-border-sm"></span>
                <i v-if="!isSavingRegistration" class="bi bi-save"></i> {{ registrationId ? 'Update' : 'Add' }}
              </button>
            </div>
            <div class="col-sm-6 col-xs-12">
              <button class="btn btn-secondary w-100" @click="backSelectParticipants">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-8">
        <div class="card form-highlight">
          <div class="card-body">
            <h4 class="card-title mb-3">
              {{ registrationDetailId ? 'Edit a' : 'Add a new' }} participant
            </h4>
            <div class="row">
              <div class="col-sm-12">
                <div class="card inner-form-highlight mb-3">
                  <div class="card-body">
                    <h6 class="card-title">Participant details</h6>
                    <div class="row" v-if="!startLoading">
                      <div class="col-sm-6 mb-2">
                        <div>
                          <label for="firstName" class="form-label">First Name *</label>
                          <input type="text" maxlength="100" @focus="validation.firstName.dirty = true"
                            v-model="vm.detail.firstName" @blur="validate" class="form-control" placeholder="John" />
                          <label class="error" v-if="!validation.firstName.valid">{{
                            validation.firstName.errorMessage
                          }}</label>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div>
                          <label for="lastName" class="form-label">Last Name *</label>
                          <input type="text" maxlength="100" @focus="validation.lastName.dirty = true"
                            v-model="vm.detail.lastName" @blur="validate" class="form-control" id="lastName"
                            placeholder="Doe" />
                          <label class="error" v-if="!validation.lastName.valid">{{
                            validation.lastName.errorMessage
                          }}</label>
                        </div>
                      </div>
                      <div class="col-sm-6 mb-2">
                        <div>
                          <label for="gender" class="form-label">Gender *</label>
                          <select class="form-select" @focus="validation.gender.dirty = true" aria-label="gender"
                            @change="validate" v-model="vm.detail.gender">
                            <option value="">Select Gender</option>
                            <option value="Male" default>Male</option>
                            <option value="Female">Female</option>
                          </select>
                          <label class="error" v-if="!validation.gender.valid">{{
                            validation.gender.errorMessage
                          }}</label>
                        </div>
                      </div>
                      <div class="col-sm-6" v-if="programData && !isMyGolf">
                        <div>
                          <label for="mobileNo" class="form-label">Mobile Number *</label>
                          <input type="text" @focus="validation.phone.dirty = true" maxlength="100" @blur="validate"
                            v-model="vm.detail.phone" class="form-control" id="mobileNo" placeholder="029999999" />
                          <label class="error" v-if="validation.phone && !validation.phone.valid">{{
                            validation.phone.errorMessage
                          }}</label>
                        </div>
                      </div>
                      <div class="col-sm-6 mb-2" v-if="programData && !isMyGolf">
                        <label for="email" class="form-label">Email *</label>
                        <input type="text" @focus="validation.email.dirty = true" @blur="validate" class="form-control"
                          id="email" v-model="vm.detail.email" placeholder="john@doe.com" />
                        <label class="error" v-if="validation.email && !validation.email.valid">{{
                          validation.email.errorMessage
                        }}</label>
                      </div>
                      <div class="col-sm-6">
                        <label for="dob" class="form-label">Date of Birth *</label>
                        <div class="input-group mb-3">
                          <VueDatePicker v-model="vm.detail.dob" 
                            format="dd/MM/yyyy" 
                            model-format="yyyy-MM-dd"
                            auto-apply 
                            clearable
                            :enable-time-picker="false" @blur="validate" :text-input="{}"
                            @focus="validation.dob.dirty = true" />
                          <span class="error" v-if="!validation.dob.valid">{{
                            validation.dob.errorMessage
                          }}</span>
                      </div>
                        </div>
                      <div class="col-sm-12 mb-3" v-if="programData && settings.showEthnicity">
                        <label for="ethnicity" class="form-label">Ethnicity</label>
                        <select class="form-select" aria-label="ethnicity" v-model="vm.detail.ethnicityId">
                          <option value="">Select Ethnicity</option>
                          <option v-for="ethnicity in ethnicityArray"
                                  :value="ethnicity.ethnicityId"
                                  :key="ethnicity.ethnicityId">
                              {{ ethnicity.description }}
                          </option>
                        </select>
                      </div>
                      <div class="col-sm-12 mb-3" v-if="programData && isMyGolf">
                        <div>
                          <label for="school" class="form-label">School</label>
                          <input class="form-control" id="school" v-model="vm.detail.school" maxlength="1000" />
                        </div>
                      </div>
                      <div class="col-sm-12 mb-3">
                        <label for="firsttime" class="form-label">Club hand? *</label>
                        <br />
                        <div class="form-check-inline">
                          <input v-model="vm.detail.playingHand" @focus="validation.value.playingHand.dirty = true"
                            @click="validate();" class="form-check-input" type="radio" id="playingHand" value="L" />
                          <label class="form-check-label" for="playingHand"> Left </label>
                        </div>
                        <div class="form-check-inline">
                          <input class="form-check-input" v-model="vm.detail.playingHand" type="radio"
                            @focus="validation.value.playingHand.dirty = true" @click="validate();"
                            name="flexRadioDefault" value="R" id="playingHand2" />
                          <label class="form-check-label" for="playingHand2"> Right </label>
                        </div>
                        <div class="error" v-if="!validation.playingHand.valid">
                          {{ validation.playingHand.errorMessage }}
                        </div>
                      </div>
                      <div class="col-sm-12 mb-3" v-if="programData && !settings.hideBornOverseasQuestion">
                        <label for="check5" class="form-label" v-if="isMyGolf">Was either parent born overseas?</label>
                        <label for="check5" class="form-label" v-else>Were you born overseas?</label>
                        <br />
                        <div class="form-check-inline">
                          <input class="form-check-input" type="radio" id="check5" value="Yes"
                            v-model="vm.detail.isEitherParentBornOverseasValue" />
                          <label class="form-check-label" for="check5"> Yes </label>
                        </div>
                        <div class="form-check-inline">
                          <input class="form-check-input" type="radio" id="check6" value="No"
                            v-model="vm.detail.isEitherParentBornOverseasValue" />
                          <label class="form-check-label" for="check6"> No </label>
                        </div>
                      </div>
                      <div class="col-sm-12 mb-3" v-if="programData && settings.showEmergencyContact && !programData.IsJunior">
                        <label class="form-label"><b>Emergency Contact</b></label>
                        <div class="mb-2">
                          <label for="mobileNo" class="form-label">Name</label>
                          <input type="text" maxlength="100" v-model="vm.detail.emergencyContactName" class="form-control" id="emergencyContactName" placeholder="John Doe" />
                        </div>
                        <div class="mb-2">
                          <label for="mobileNo" class="form-label">Relationship</label>
                          <input type="text" maxlength="100" v-model="vm.detail.emergencyContactRelationship" class="form-control" id="emergencyContactRelationship" placeholder="Father, mother, wife, husband etc." />
                        </div>
                        <div class="mb-2">
                          <label for="mobileNo" class="form-label">Phone</label>
                          <input type="text" maxlength="100" v-model="vm.detail.emergencyContactPhone" class="form-control" id="emergencyContactPhone" placeholder="029999999" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card inner-form-highlight mb-2">
                  <div class="card-body">
                    <h6 class="card-title">Medical details</h6>
                    <div class="row" v-if="!startLoading">
                      <div class="col-sm-12">
                        <div class="mb-3">
                          <label for="check7" class="form-label">
                            Does the participant identify as living with a disability /
                            disabilities?
                          </label>
                          <br />
                          <div class="form-check-inline">
                            <input class="form-check-input" type="radio" value="Yes" id="check7"
                              v-model="vm.detail.hasSpecialNeedsValue" />
                            <label class="form-check-label" for="check7"> Yes </label>
                          </div>
                          <div class="form-check-inline">
                            <input class="form-check-input" type="radio" value="No" id="check8"
                              v-model="vm.detail.hasSpecialNeedsValue" />
                            <label class="form-check-label" for="check8"> No </label>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12 mb-3" v-if="vm.detail.hasSpecialNeedsValue == 'Yes'">
                        <label for="additionalInfo" class="form-label">If yes, please provide additional
                          details.</label>
                        <textarea rows="3" maxlength="1000" class="form-control" id="additionalInfo"
                          v-model="vm.detail.specialNeedsComment"></textarea>
                      </div>
                      <div class="col-sm-12">
                        <label for="additionalInfo1" class="form-label">Please list any allergies or medical information
                          the deliverer/s should
                          know about.</label>
                        <textarea rows="3" maxlength="1000" class="form-control" id="additionalInfo1"
                          v-model="vm.detail.otherComments"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mobile-buttons-container mt-3 d-block d-lg-none">
          <div class="d-flex flex-row" v-if="!startLoading">
            <button class="btn btn-primary w-100" :disabled="isSavingRegistration" @click="onSave">
              <span v-if="isSavingRegistration" class="spinner-border spinner-border-sm"></span>
              <i v-if="!isSavingRegistration" class="bi bi-save"></i> {{ registrationId ? 'Update' : 'Add' }}
            </button>
            <button class="btn btn-secondary w-100" :disabled="isSavingRegistration"
              @click="backSelectParticipants">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <h3>You do not have permissions to access this.</h3>
    </div>
  </div>
  <Notification ref="notificationMsg" colorScheme="text-bg-success">
    <template #body> Participant successfully added! </template>
  </Notification>
  <Notification ref="notificationError" colorScheme="text-bg-danger">
    <template #body>{{ notificationErrorMessage }}</template>
  </Notification>
  <AppLoader v-if="startLoading" />
</template>

<script setup lang="ts">
import router from '@/router'
import { useProgramStore } from '@/stores/program-store'
import { reactive, ref, watch, onMounted, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useRoute } from 'vue-router'
import Notification from '@/components/common/Notification.vue'
import { useCurrencyStore } from '@/stores/currency-store'
import { useAuthStore } from "@/stores/auth-store";
import AppLoader from "../components/AppLoader.vue";
import { useSettingStore } from "@/stores/setting-store";
import { useTermsStore } from "@/stores/language-terms";
const { terms } = storeToRefs(useTermsStore());

const { getLoginOrgInfo } = useAuthStore();
const { getDefaultCurrency } = useCurrencyStore()

import type { IGolfausProgramRegistrationVm } from '@/types'
import type { IGolfausProgramRegistrationDetailVm } from '@/types'
import moment from 'moment'

const { getSetting } = useSettingStore();
const { setting } = storeToRefs(useSettingStore());
const settings = ref(setting);

const isValidProgram = ref(true);
let notificationMsg = ref<any | null>(null)
let notificationError = ref<any | null>(null);
const notificationErrorMessage = ref<string>('');
const { currency } = storeToRefs(useCurrencyStore())
const route = useRoute()
const {
  getProgramById,
  createUpdateParticipationRegistration,
  getParticipationRegistrationDetail,
  getEthnicities
} = useProgramStore()

const startLoading = ref(true);
const { orgInfo } = storeToRefs(useAuthStore());

const {
  programData,
  isSavingRegistration,
  ethnicities
} = storeToRefs(useProgramStore());

const ethnicityArray = ref(ethnicities);

let vm = reactive<IGolfausProgramRegistrationVm>({
  detail: {} as IGolfausProgramRegistrationDetailVm
} as IGolfausProgramRegistrationVm);

let allValid = ref(false);

const validation = ref({
  firstName: {
    valid: true,
    errorMessage: '',
    dirty: false
  },
  lastName: {
    valid: true,
    errorMessage: '',
    dirty: false
  },
  gender: {
    valid: true,
    errorMessage: '',
    dirty: false
  },
  dob: {
    valid: true,
    errorMessage: '',
    dirty: false
  },
  phone: {
    valid: true,
    errorMessage: '',
    dirty: false
  },
  regionId: {
    valid: true,
    errorMessage: '',
    dirty: false
  },
  email: {
    valid: true,
    errorMessage: '',
    isEmail: true,
    dirty: false
  },
  // school: {
  //   valid: true,
  //   errorMessage: ''
  // },
  playingHand: {
    valid: true,
    errorMessage: '',
    dirty: false
  },
} as any);

const guardianValidation = ref({
  guardianFirstName: {
    valid: true,
    errorMessage: '',
    dirty: false
  },
  guardianLastName: {
    valid: true,
    errorMessage: '',
    dirty: false
  },
  guardianEmail: {
    valid: true,
    errorMessage: '',
    isEmail: true,
    dirty: false
  },
  guardianPhone: {
    valid: true,
    errorMessage: '',
    dirty: false
  }
} as any);

const programUID = computed(() => {
  return route.params.programUID as string;
});

const registrationId = computed(() => {
  return route.params.rId as string;
});

const registrationDetailId = computed(() => {
  return route.params.rdId as string;
});

const isMyGolf = computed(() => {
  return programData.value && programData.value.programCategoryId == 1;
});

const backSelectParticipants = async () => {
  await router.push({
    name: 'ParticipationProgramParticipants',
    params: {
      programUID: programData.value.programUID
    },
    query: route.query
  });
};

onMounted(async () => {
  await getLoginOrgInfo();
  await getProgramById(programUID.value, orgInfo?.value?.clubId);
  await getSetting();

  if (programData.value) {
    isValidProgram.value = true;
  } else {
    isValidProgram.value = false
  }

  await getDefaultCurrency();
  await getEthnicities();

  if (isMyGolf.value) {
    delete validation.value['email'];
    delete validation.value['regionId'];
    delete validation.value['phone'];
  } else {
    delete validation.value['school'];
    delete validation.value['regionId'];
  }

  await tryLoadRegistrationDetail();

  startLoading.value = false;
})

const validate = () => {
  if (vm.detail) {
    let keys = Object.keys(validation.value);
    for (var i = 0; i < keys.length; i++) {
      let key = keys[i];
      const validationObj = validation.value[key];
      const modelValue = vm.detail[key];

      const modelToched = validationObj.dirty;
      if (!modelToched) {
        validationObj.errorMessage = '';
        continue;
      }

      validationObj.valid = modelValue && modelValue != null && modelValue != '';
      if (!validationObj.valid) {
        if (key == 'regionId') {
          validationObj.errorMessage = `Invalid ${settings ? settings.value.stateName : 'State'}`;
        }
        else if (key == 'dob') {
          validationObj.errorMessage = `Invalid Date of Birth`;
        }
        else if (key == 'packIsRequestedValue' && isMyGolf.value) {
          validationObj.errorMessage = `Invalid Participant Pack`;
        }
        else {
          validationObj.errorMessage = `Invalid ${toText(key)}`;
        }
      } else {
        if (key == 'dob') {
          const dateDiff = moment(modelValue).diff(moment(new Date()), 'years', true);
          const years = Math.abs(Math.floor(dateDiff));
          validationObj.valid = years <= settings.value.maximumAgeForCreatingMember;
          if (!validationObj.valid) {
            validationObj.errorMessage = `Invalid Date of Birth`;
            return;
          }
        }

        validationObj.errorMessage = '';
      }

      if (validationObj.valid &&
        !isMyGolf.value &&
        validationObj.isEmail) {
        let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        validationObj.valid = modelValue.match(regex);
        validationObj.errorMessage = !validationObj.valid ? `Invalid email` : '';
      }
    }

    if (programData.value && isMyGolf.value) {
      keys = Object.keys(guardianValidation.value);
      for (var i = 0; i < keys.length; i++) {
        let key = keys[i];
        const validationObj = guardianValidation.value[key];
        const modelValue = (vm as any)[key];

        const modelToched = validationObj.dirty;
        if (!modelToched) {
          validationObj.errorMessage = '';
          continue;
        }

        validationObj.valid = modelValue != null && modelValue != '' && typeof modelValue != 'undefined';
        validationObj.errorMessage = !validationObj.valid ? `Invalid ${toText(key)}` : '';

        if (validationObj.valid &&
          validationObj.isEmail) {
          let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
          validationObj.valid = modelValue && modelValue.match(regex)?.length > 0;
          validationObj.errorMessage = !validationObj.valid ? `Invalid email` : '';
        }
      }
    }

    const isValid = (validationModel: any) => {
      return Object.keys(validationModel).every((x) => validationModel[x].valid);
    }

    allValid.value = isValid(validation.value) && (isMyGolf.value ? isValid(guardianValidation.value) : true);
  }
}

const tryLoadRegistrationDetail = async () => {
  if (registrationId.value && registrationDetailId.value) {
    var result = await getParticipationRegistrationDetail(
      registrationDetailId.value
    );
    Object.assign(vm, result);

    vm.programCategoryId = programData.value.programCategoryId;
    vm.totalAmountDue = programData.value.programCostFirstParticipant;
    vm.countryId = programData.value.countryId;
    vm.associationId = programData.value.associationId;
    vm.clubId = programData.value.clubId;
    vm.regionId = result.detail.regionId ?? programData.value.regionId;
    vm.detail.gender = result.detail.gender?.trim();
    vm.detail.regionId = vm.regionId;

    if (vm.detail.isEitherParentBornOverseas != null) {
      vm.detail.isEitherParentBornOverseasValue = vm.detail.isEitherParentBornOverseas ? 'Yes' : 'No';
    }

    if (vm.detail.isFirstTimeParticipant != null) {
      vm.detail.isFirstTimeParticipantValue = vm.detail.isFirstTimeParticipant ? 'Yes' : 'No';
    }

    if (vm.detail.isIndigenous != null) {
      vm.detail.isIndigenousValue = vm.detail.isIndigenous ? 'Yes' : 'No';
    }

    if (vm.detail.hasSpecialNeeds != null) {
      vm.detail.hasSpecialNeedsValue = vm.detail.hasSpecialNeeds ? 'Yes' : 'No';
    }
  }
}

const toText = (value: string) => {
  const result = value.replace(/([A-Z])/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1);
}

const makeValidationDirty = () => {
  let keys = Object.keys(validation.value);
  for (var i = 0; i < keys.length; i++) {
    let key = keys[i];
    const validationObj = validation.value[key];
    validationObj.dirty = true;
  }

  keys = Object.keys(guardianValidation.value);
  for (var i = 0; i < keys.length; i++) {
    let key = keys[i];
    const validationObj = guardianValidation.value[key];
    validationObj.dirty = true;
  }
}

const onSave = async () => {

  if (startLoading.value || isSavingRegistration.value) return

  makeValidationDirty();
  validate();

  if (!allValid.value) {
    return
  }

  if (registrationId.value) {
    vm.participationRegistrationUID = registrationId.value;
  }

  vm.programUID = programData.value.programUID;
  vm.status = 'CREATED';
  vm.isPaidOnline = false;
  vm.programCategoryId = programData.value.programCategoryId;
  vm.totalAmountDue = programData.value.programCostFirstParticipant;

  vm.countryId = programData.value.countryId;
  vm.associationId = programData.value.associationId;
  vm.clubId = programData.value.clubId;
  vm.regionId = programData.value.regionId;

  if (registrationDetailId.value) {
    vm.detail.participationRegistrationDetailUID = registrationDetailId.value;
  }

  if (vm.detail.isEitherParentBornOverseasValue) {
    vm.detail.isEitherParentBornOverseas = vm.detail.isEitherParentBornOverseasValue == "Yes";
  }

  if (vm.detail.isFirstTimeParticipantValue) {
    vm.detail.isFirstTimeParticipant = vm.detail.isFirstTimeParticipantValue == "Yes";
  }

  if (vm.detail.isIndigenousValue) {
    vm.detail.isIndigenous = vm.detail.isIndigenousValue == "Yes";
  }

  if (vm.detail.hasSpecialNeedsValue) {
    vm.detail.hasSpecialNeeds = vm.detail.hasSpecialNeedsValue == "Yes";
  }

  vm.detail.dOB = moment(vm.detail.dob).utc(true).toDate();
  vm.detail.isManuallyCreated = true;
  vm.detail.programAmount = programData.value.programCostFirstParticipant;
  vm.detail.amountDue = programData.value.programCostFirstParticipant;

  vm.details = Array<IGolfausProgramRegistrationDetailVm>();
  vm.details.push({ ...vm.detail });

  try {
    const result = await createUpdateParticipationRegistration(vm);
    if (result === true) {
      notificationMsg?.value?.show();
      setTimeout(async () => {
        await router.push({
          name: 'ParticipationProgramParticipants',
          params: {
            programUID: programData.value.programUID
          },
          query: route.query
        });
      }, 1000);
    } else {
      if (result === false) {
        notificationErrorMessage.value = 'Something went wrong. Try again.';
      } else {
        notificationErrorMessage.value = result;
      }
      notificationError.value.show();
    }
  } catch (error: any) {
    console.log(error.response);
  }
}

</script>

<style scoped>
.form-highlight {
  background-color: #d9e2f4;
}

.inner-form-highlight {
  background-color: #edf1f8;
}

.orange {
  color: #fd7e14;
}

.form-check-label {
  margin-left: 5px;
}

.error {
  color: red;
  font-size: 12px;
  margin-bottom: 10px;
}
</style>
